import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer'
import { KVResolutionQuality } from 'types'

import { KVMessageDef } from './index'

export function getControlMessage() {
  return {
    type: 'control',
    requiredData: ['control'],

    callback: (
      json: Record<string, unknown>,
      kv: KestrelViewerMessageCallbackAPI
    ) => {
      if (!kv.pixelStream) return

      if (json.control && kv.videoParent.current) {
        const MAX_DIMENSION = 2880 // 1920 px * 1.5

        const scale = kv.resolutionQuality ?? KVResolutionQuality.Standard
        const containerWidthScaled = kv.videoParent.current.clientWidth * scale
        const containerHeightScaled =
          kv.videoParent.current.clientHeight * scale

        const widthScale =
          containerWidthScaled > MAX_DIMENSION
            ? MAX_DIMENSION / containerWidthScaled
            : 1
        const heightScale =
          containerHeightScaled > MAX_DIMENSION
            ? MAX_DIMENSION / containerHeightScaled
            : 1
        const constraintScale = Math.max(widthScale, heightScale)

        kv.pixelStream.emitCommand({
          'Resolution.Width': Math.round(
            containerWidthScaled * constraintScale
          ),
          'Resolution.Height': Math.round(
            containerHeightScaled * constraintScale
          ),
        })
      } else {
        // Disable user interaction and notify user
      }
    },
  } as KVMessageDef
}
